import React from 'react';

import { useRouter } from 'next/router';

import {
  generateCardsUrl,
  navigationHandler
} from 'src/utils/cardsUrlGenerator';
import { CountryCode } from 'src/utils/constants/stringConstants';

import { useAppStore } from 'src/hooks/useAppStore';
import ThumbnailImage from '../../components/ThumbnailImage';
import { ThumbnailComponentProps } from '../../types';
import * as customStyled from './styles';

const Circular: React.FC<ThumbnailComponentProps> = ({
  title,
  tagName,
  imageUrl,
  slug,
  assetType,
  businessType,
  billingType,
  content,
  thumbnailType,
  contentPartner,
  content_partner_details,
  joystickIconCheck
}) => {
  const { appConfig, usersLocationData } = useAppStore();
  const router = useRouter();
  let slugData = content ? generateCardsUrl(content) ?? slug : '';

  if (slugData) {
    slugData = slugData.startsWith('/')
      ? slugData
      : slugData.startsWith('http')
      ? slugData
      : `/${slugData}`;
  }
  if (
    appConfig.isRequestedByBot &&
    usersLocationData?.country_code !== CountryCode.IN
  ) {
    const globalRegex = /\/global\//;
    slugData = slugData
      .replace(globalRegex, '/')
      .replace(`/${router.locale}/`, '/');
  }
  const watchCallback = (e: any) => {
    e.preventDefault();
    if (slugData) {
      navigationHandler(slugData, (slugData) =>
        router.push(slugData, slugData)
      );
    }
  };

  return (
    <div
      title={title}
      className="keen-slider__slide"
      css={customStyled.container}>
      <div css={customStyled.contentItemCard}>
        <ThumbnailImage
          imageUrl={imageUrl}
          tagName={tagName}
          assetType={assetType}
          title={title}
          slug={slugData}
          businessType={businessType}
          billingType={billingType}
          onClickHandler={watchCallback}
          thumbnailType={thumbnailType}
          contentPartner={contentPartner}
          content_partner_details={content_partner_details}
          joystickIconCheck={joystickIconCheck}
        />
        <footer>
          <h4 css={customStyled.contentTitle}>{title}</h4>
        </footer>
      </div>
    </div>
  );
};

export default Circular;
